// src/components/layouts.js
export const layouts = {
  english: {
    default: [
      "q w e r t y u i o p",                  // Row 1
      "a s d f g h j k l",                     // Row 2
      "{shift} z x c v b n m {backspace}",     // Row 3
      "{numbers} {space} {send}"      // Row 4
    ],
    shift: [
      "Q W E R T Y U I O P",
      "A S D F G H J K L",
      "{shift} Z X C V B N M {backspace}",
      "{numbers} {space} {send}"
    ],
    numbers: [
      "1 2 3 4 5 6 7 8 9 0 {backspace}",
      "- / : ; ( ) ₹ & @ \"",
      ". , ? ! ' +",
      "{letters} {space} {send}"
    ],
  },
  marathi: {
    page1: [
      "अ आ इ ई उ ऊ ए ऐ ओ औ",                    // Row 1 - Independent vowels
      "क ख ग घ ङ च छ ज झ ञ",               // Row 2 - First set of consonants (same as default)
      "{page1indicator} ट ठ ड ढ ण त थ द ध न {backspace}", // Row 3 - Split consonants from default
      "{numbers} {space} {send}"          // Row 4
    ],
    page2: [
      "ा ि ी ु ू ृ े ै ो ौ ं ँ ः ्",                // Row 1 - Matras (same as default)
      "प फ ब भ म य र ल व श",         // Row 2 - Remaining consonants + conjuncts from default
      "{page2indicator} ष स ह ळ ज्ञ त्र क्ष श्र {backspace}",                                // Row 3 - Backspace only
      "{numbers} {space} {send}"          // Row 4
    ],
    numbers: [
      "१ २ ३ ४ ५ ६ ७ ८ ९ ० {backspace}",
      "- / : ; ( ) ₹ & @ \"",
      ". , ? ! '",
      "{letters} {space} {send}"
    ],
  },
  hindi: {
    page1: [
      "अ आ इ ई उ ऊ ए ऐ ओ औ",                    // Row 1 - Independent vowels
      "क ख ग घ ङ च छ ज झ ञ",               // Row 2 - First set of consonants (same as default)
      "{page1indicator} ट ठ ड ढ ण त थ द ध न {backspace}", // Row 3 - Split consonants from default
      "{numbers} {space} {send}"          // Row 4
    ],
    page2: [
      "ा ि ी ु ू ृ े ै ो ौ ं ँ ः ्",                // Row 1 - Matras (same as default)
      "प फ ब भ म य र ल व श",         // Row 2 - Remaining consonants + conjuncts from default
      "{page2indicator} ष स ह ळ ज्ञ त्र क्ष श्र {backspace}",                                // Row 3 - Backspace only
      "{numbers} {space} {send}"          // Row 4
    ],
    numbers: [
      "१ २ ३ ४ ५ ६ ७ ८ ९ ० {backspace}",
      "- / : ; ( ) ₹ & @ \"",
      ". , ? ! '",
      "{letters} {space} {send}"
    ],
  }
};
